// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"367":"b536a0f1","831":"bd904a5c"}[chunkId] || chunkId) + "." + {"367":"11dbe0bbd0b037f3","777":"2237510106d3d5f3","831":"4e061b4166aff566","967":"c89322f4f5a607d8"}[chunkId] + ".js";
};